module.exports = {"code":"SSO-200-023-001","messages":["Successfully logged in."],"status":true,"httpCode":"200","developerMessages":[],"ssoToken":"4662308d-8b32-434f-b3d0-4d473e169495"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/normalEmailLogin.json
// module id = 408
// module chunks = 0